import { render, staticRenderFns } from "./add-litter-container.vue?vue&type=template&id=1ac6612f&scoped=true&lang=pug"
import script from "./add-litter-container.js?vue&type=script&lang=js&external"
export * from "./add-litter-container.js?vue&type=script&lang=js&external"
import style0 from "./add-litter-container.vue?vue&type=style&index=0&id=1ac6612f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac6612f",
  null
  
)

export default component.exports